import {combineReducers} from "redux";

import {eshop} from "./reducers";

export const rootReducer = combineReducers({
    builder: eshop.builder.reducer
});

